export default __webpack_public_path__ + "static/media/cloud-upload.5c43f246.svg";